 <!-- skeleton -->
 <ng-template #loadingSkeleton>
  <nz-skeleton class="bg-white dark:bg-white/10 rounded-6 p-[30px] pt-[15px]" [nzShape]="circle" [nzActive]="true"
    [nzParagraph]="{ rows: 15}"></nz-skeleton>
</ng-template>
<!-- skeleton -->
 <div nz-col nzXs="24" nzMd="12">
   <ng-template #newContactContent>
     <form nz-form nzLayout="vertical">
       <nz-form-item>
         <nz-form-control>
           <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Name:</nz-form-label>
           <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10" type="text" nz-input placeholder="Input Name">
         </nz-form-control>
       </nz-form-item>
       <nz-form-item>
         <nz-form-control>
           <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Email address:</nz-form-label>
           <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10" type="email" nz-input placeholder="name@example.com">
         </nz-form-control>
       </nz-form-item>
       <nz-form-item>
         <nz-form-control>
           <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Phone Number:</nz-form-label>
           <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10" type="email" nz-input placeholder="+440 2546 5236">
         </nz-form-control>
       </nz-form-item>
       <nz-form-item>
         <nz-form-control>
           <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Position:</nz-form-label>
           <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10" type="email" nz-input placeholder="Input Position">
         </nz-form-control>
       </nz-form-item>
       <nz-form-item class="mb-0">
         <nz-form-control>
           <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Company Name:</nz-form-label>
           <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10" type="email" nz-input placeholder="Company Name">
         </nz-form-control>
       </nz-form-item>
     </form>
   </ng-template>
   <!-- :End New project added -->
 </div>
<div nz-row nzGutter="25" class="mt-[4px]">
  <div nz-col nzXs="24" nzMd="12" class="mb-[25px]">
   <div class="flex items-center flex-wrap gap-[20px]  max-lg:justify-center">
     <!-- Search Box -->
     <h1 class="text-dark dark:text-white/[.87] text-[22px] font-semibold mb-0">Contacts</h1>
     <div class="3xl:w-[280px] max-ssm:w-full [&>div>div.ant-select-selector]:border-0">
       <nz-input-group class="bg-white dark:bg-white/10 rounded-[6px] h-[40px] flex items-center px-[20px]">
         <input class="bg-transparent border-none text-[15px] shadow-none text-dark dark:text-white/[.87] flex items-center" type="text" nz-input
           placeholder="Search contacts" [(ngModel)]="searchInput" (ngModelChange)="search()">
         <i class="text-theme-gray dark:text-white/[.87]" nz-icon nzType="search"></i>
       </nz-input-group>
     </div>
     <!-- :End Search Box -->
   </div>
  </div>
  <div nz-col nzXs="24" nzMd="12" class="mb-[25px]">
    <!-- New Contact -->
    <div class="flex items-center justify-center md:justify-end">
     <button class="flex items-center px-[14px] text-sm text-white rounded-md font-semibold bg-primary border-primary h-10 gap-[6px]" nz-button (click)="showNewContact(newContactContent)">
       <i class="text-[12px]" nz-icon nzType="plus"></i>
       <span class="m-0">Add New</span>
     </button>
   </div>
     <!-- end: New Contact -->
  </div>
</div>
<div nz-row nzGutter="25">
 <div nz-col nzXs="24" class="mb-[25px]">
  <ng-container *ngIf="showContent; else loadingSkeleton">
    <div class="bg-white border-none dark:bg-white/10 p-[30px] rounded-xl mb-[30px] overflow-x-auto w-full">
      <nz-table [nzData]="['']" [nzFrontPagination]="false" [nzShowPagination]="false">
        <thead>
          <tr>
            <th class="bg-regularBG dark:bg-[#323440] px-[20px] py-[16px] text-start text-light dark:text-white/[.87] text-15px font-medium border-none before:hidden rounded-s-[10px] capitalize">
              <label nz-checkbox [(ngModel)]="allChecked" (ngModelChange)="updateAllChecked()"[nzIndeterminate]="indeterminate"></label>
            </th>
            <th
              class="bg-regularBG dark:bg-[#323440] px-4 py-[16px] text-start text-dark/[.85] dark:text-white/[.87] text-[15px] font-medium border-none before:hidden capitalize">
              user</th>
            <th
              class="bg-regularBG dark:bg-[#323440] px-4 py-[16px] text-start text-dark/[.85] dark:text-white/[.87] text-[15px] font-medium border-none before:hidden capitalize">
              Email</th>
            <th
              class="bg-regularBG dark:bg-[#323440] px-4 py-[16px] text-start text-dark/[.85] dark:text-white/[.87] text-[15px] font-medium border-none before:hidden capitalize">
              Company</th>
            <th
              class="bg-regularBG dark:bg-[#323440] px-4 py-[16px] text-start text-dark/[.85] dark:text-white/[.87] text-[15px] font-medium border-none before:hidden capitalize">
              Position</th>
            <th
              class="bg-regularBG dark:bg-[#323440] px-4 py-[16px] text-start text-dark/[.85] dark:text-white/[.87] text-[15px] font-medium border-none before:hidden capitalize">
              Phone</th>
            <th class="bg-regularBG dark:bg-[#323440] px-[20px] py-[16px] text-end text-dark/[.85] dark:text-white/[.87] text-[15px] font-medium border-none before:hidden rounded-e-[10px] capitalize">
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="group" *ngFor="let item of ContactGrid">
            <td class="ps-[20px] pe-[20px] py-[9px] text-start last:text-end text-dark dark:text-white/[.87] group-hover:bg-transparent text-15 font-medium border-none before:hidden">
                <label class="me-[15px]" nz-checkbox [(ngModel)]="item.checked"
                (ngModelChange)="updateSingleChecked()"></label>
            </td>
            <td class="px-[20px] py-[9px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-none group-hover:bg-transparent">
              <div class="flex items-center whitespace-nowrap gap-[10px]">
                  <img class="inline-block w-8 h-8 rounded-full" src="assets/images/avatars/{{item.avatar}}" alt="img">
                <div>
                  <h6 class="mb-0 text-body dark:text-white/60 text-[15px] font-medium">{{item.name}}</h6>
                  <span class="text-[12px] font-normal text-light dark:text-white/60">{{item.rule}}</span>
                </div>
              </div>
            </td>
            <td class="px-[20px] py-[9px] font-normal last:text-end lowercase text-[14px] text-dark dark:text-white/[.87] border-none group-hover:bg-transparent">{{item.user[1].name}}</td>
            <td class="px-[20px] py-[9px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-none group-hover:bg-transparent">{{item.user[2].name}}</td>
            <td class="px-[20px] py-[9px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-none group-hover:bg-transparent">{{item.rule}}</td>
            <td class="px-[20px] py-[9px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-none group-hover:bg-transparent">{{item.user[0].name}}</td>
            <td class="text-right ps-[20px] pe-[20px] py-[9px] font-normal last:text-end capitalize text-[14px] text-dark dark:text-white/[.87] border-none group-hover:bg-transparent">
                <div class="flex items-center gap-[10px]">
                  <div>
                    <span class="text-light-extra dark:text-white/60 [&>svg]:w-[16px] [&>svg]:h-[16px] [&.active>svg]:text-warning {{item.star}}"
                        nz-icon nzType="star" nzTheme="outline">
                      </span>
                  </div>
                  <a class="text-light-extra text-18" nz-dropdown nzPlacement="bottomRight" nzTrigger="click"
                      [nzDropdownMenu]="projectListSetting2">
                      <span nz-icon nzType="more" nzTheme="outline"></span>
                    </a>
                    <nz-dropdown-menu #projectListSetting2="nzDropdownMenu">
                      <ul
                        class="block bg-white dark:bg-[#1b1e2b] shadow-regular dark:shadow-[0_5px_30px_rgba(1,4,19,.60)] rounded-4 capitalize"
                        nzSelectable>
                        <li
                          class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87] gap-[6px]"
                          [routerLink]="['/apps/projects/project-details']">
                          <i nz-icon nzType="eye" theme="outline"></i>
                          <span>View</span>
                        </li>
                        <li
                          class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87] gap-[6px]"
                          >
                          <i nz-icon nzType="edit" theme="outline"></i>
                          <span class="m-l-10">Edit</span>
                        </li>
                        <li
                          class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87] gap-[6px]"
                          >
                          <i nz-icon nzType="delete" theme="outline"></i>
                          <span>Delete</span>
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </ng-container>
 </div>
</div>
